// 權限資源前端 catalog（前端側單一事實來源）。
// 與後端 CRM.Application/Constants/ResourceCatalog 對稱：前端管 router/sidebar 的 nav presence。

export const MENU_RESOURCE_KEYS = Object.freeze({
  PERMISSION: 'permission_module',
  BASIC: 'basic_module',
  SALES: 'sales_module',
  INSTALL: 'install_module',
  MONTH: 'month_module'
})

const FRONTEND_MENU_KEYS = Object.freeze([
  MENU_RESOURCE_KEYS.PERMISSION,
  MENU_RESOURCE_KEYS.BASIC,
  MENU_RESOURCE_KEYS.SALES,
  MENU_RESOURCE_KEYS.INSTALL,
  MENU_RESOURCE_KEYS.MONTH
])

export function buildResourceRouteMap (routes) {
  const resourceRouteMap = {}
  for (const route of (routes || [])) {
    const permission = route.meta && route.meta.requiresPermission
    if (!route.path || !permission || !permission.resource) continue

    resourceRouteMap[permission.resource] = route.path
  }

  return Object.freeze(resourceRouteMap)
}

export function buildFrontendDeclaredKeys (routes) {
  return new Set([
    ...FRONTEND_MENU_KEYS,
    ...extractDeclaredKeys(routes)
  ])
}

// 顯式公開 / 刻意不納管的 route path —— 對應後端 [AllowAnonymous] 的 opt-out，或無對應 catalog 資源的舊路由。
// /update_customer_repair：reverse-orphan，未 seed 至 catalog，加 requiresPermission 會 fail-closed 永遠攔截（router/index.js 註解）。
// /month、/init_month、/discount：已被 /new_month、/new_init_month、/new_discount 取代——sidebar 只連新頁、新頁各自已掛
//   requiresPermission（new_month / new_init_month / new_discount）。舊路由保留相容但無 sidebar 入口，故不單獨註冊。
export const PUBLIC_ROUTE_PATHS = new Set([
  '/', '/login', '/permission',
  '/update_customer_repair', '/month', '/init_month', '/discount'
])

/** 從 routes 抽出已宣告的 resource key 集合（供跨端對帳）。 */
export function extractDeclaredKeys (routes) {
  const keys = new Set()
  for (const r of routes) {
    const rp = r.meta && r.meta.requiresPermission
    if (rp && rp.resource) keys.add(rp.resource)
  }
  return keys
}

/** 回傳「缺 requiresPermission 且非顯式 public」的 route path 清單（前端強制註冊驗證）。 */
export function validateRouteRegistration (routes) {
  const violations = []
  for (const r of routes) {
    if (!r.path) continue
    const declared = r.meta && r.meta.requiresPermission
    if (!declared && !PUBLIC_ROUTE_PATHS.has(r.path)) {
      violations.push(r.path)
    }
  }
  return violations
}

/** 回傳「有 link 但缺 requires 且非顯式 public」的 sidebar 項目 link 清單（前端強制註冊驗證，sidebar 端）。
 *  groups = App.vue 的巢狀 sidebar items（{ moduleKey, items: [{ link, requires }] }），遞迴掃葉節點。 */
export function validateSidebarRegistration (groups) {
  const violations = []
  const walk = (nodes) => {
    for (const n of (nodes || [])) {
      if (n.items) walk(n.items)
      if (n.link && !(n.requires && n.requires.resource) && !PUBLIC_ROUTE_PATHS.has(n.link)) {
        violations.push(n.link)
      }
    }
  }
  walk(groups)
  return violations
}
